<template>
  <sup
    class="VChangeIndicator"
    v-if="newValue !== oldValue"
    :class="{ 'is-decrease': isDecrease }"
  >
    <chevrons-up-icon v-if="!isDecrease" class="icon" size="1x" />
    <chevrons-down-icon v-else class="icon" size="1x" />
    <span v-if="!percentage || (percentage && isOpposite)">
      {{ Math.abs(newValue - oldValue).toFixed(decimals) }}
    </span>
    <span v-else
      >{{
        Math.abs(((newValue - oldValue) / oldValue) * 100).toFixed(decimals)
      }}%
    </span>
  </sup>
</template>

<script>
import { ChevronsUpIcon, ChevronsDownIcon } from "@zhuowenli/vue-feather-icons";
export default {
  name: "VChangeIndicator",
  components: { ChevronsDownIcon, ChevronsUpIcon },
  props: {
    oldValue: {
      required: true
    },
    newValue: {
      required: true,
      type: Number
    },
    percentage: {
      required: false,
      default: false,
      type: Boolean
    },
    decimals: {
      required: false,
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isDecrease: false,
      isOpposite: false
    };
  },
  methods: {
    showOpposite() {
      this.isOpposite = !this.isOpposite;
    }
  },
  mounted() {
    this.isDecrease = this.newValue < this.oldValue;
  }
};
</script>

<style lang="scss" scoped>
.VChangeIndicator {
  color: green;
  font-size: 0.9em;
  border-left: 2px solid #ebebeb;
  padding-left: 0.2em;
  margin-left: 0.1em;
  .icon {
    display: inline-block;
    vertical-align: top;
    margin-right: -0.1em;
    margin-top: 0.1em;
  }
  &.is-decrease {
    color: red;
  }
}
</style>
